export default __webpack_public_path__ + "static/media/CalebAppleton.3626bac9.jpg";